"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _spinner = _interopRequireDefault(require("../spinner/spinner.presenter"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

// eslint-disable-next-line sonarjs/cognitive-complexity
var InputField = function InputField(_ref) {
  var label = _ref.label,
    uniqueID = _ref.uniqueID,
    validation = _ref.validation,
    value = _ref.value,
    _ref$inputType = _ref.inputType,
    inputType = _ref$inputType === void 0 ? 'text' : _ref$inputType,
    placeholder = _ref.placeholder,
    explanation = _ref.explanation,
    onChange = _ref.onChange,
    onKeyDown = _ref.onKeyDown,
    onBlur = _ref.onBlur,
    options = _ref.options,
    isDatalistFetching = _ref.isDatalistFetching,
    datalist = _ref.datalist,
    isReadOnly = _ref.isReadOnly,
    isDisabled = _ref.isDisabled,
    isSmall = _ref.isSmall,
    isRequired = _ref.isRequired,
    minNumber = _ref.minNumber,
    maxNumber = _ref.maxNumber,
    _ref$numberStep = _ref.numberStep,
    numberStep = _ref$numberStep === void 0 ? 1 : _ref$numberStep,
    _ref$autofocus = _ref.autofocus,
    autofocus = _ref$autofocus === void 0 ? false : _ref$autofocus;
  var validationFailed = validation && validation.find(function (condition) {
    return condition.criteria(value);
  });
  var displayInfoText = validationFailed ? validationFailed.message : explanation;
  return _react.default.createElement("div", {
    className: "agillicInputField ".concat(isSmall ? 'small' : ''),
    "data-testid": uniqueID
  }, label &&
  // eslint-disable-next-line jsx-a11y/label-has-for
  _react.default.createElement("label", {
    htmlFor: uniqueID,
    "data-testid": "label"
  }, label), isRequired && _react.default.createElement("span", {
    className: "required",
    "data-testid": "required"
  }), _react.default.createElement("div", {
    className: (0, _classnames.default)('inputContainer', {
      dropDown: inputType === 'dropDown'
    }),
    "data-testid": "inputContainer"
  }, inputType === 'dropDown' && (!(isReadOnly || options.length === 1) ? _react.default.createElement("select", {
    value: value,
    placeholder: placeholder,
    onChange: onChange,
    onBlur: onBlur,
    id: uniqueID,
    className: (0, _classnames.default)('inputElement', {
      invalid: validationFailed
    }),
    disabled: isDisabled
  }, options.map(function (_ref2) {
    var displayName = _ref2.displayName,
      optionValue = _ref2.value;
    return _react.default.createElement("option", {
      value: optionValue,
      key: optionValue
    }, displayName);
  })) : _react.default.createElement("input", {
    value: value,
    placeholder: placeholder,
    id: uniqueID,
    className: "inputElement",
    disabled: isDisabled,
    readOnly: true
  })), inputType === 'text' && _react.default.createElement(_react.Fragment, null, _react.default.createElement("div", {
    className: "inputWrapper"
  }, _react.default.createElement("input", {
    autoFocus: autofocus,
    value: value,
    placeholder: placeholder,
    onChange: onChange,
    onBlur: onBlur,
    onKeyDown: onKeyDown,
    id: uniqueID,
    className: (0, _classnames.default)('inputElement', {
      invalid: validationFailed,
      spaceForSpinner: isDatalistFetching
    }),
    readOnly: isReadOnly,
    disabled: isDisabled,
    list: "".concat(uniqueID, "-datalist")
  }), isDatalistFetching && _react.default.createElement(_spinner.default, {
    size: 10,
    isExtraThin: true
  })), datalist && datalist.length > 0 && _react.default.createElement("datalist", {
    id: "".concat(uniqueID, "-datalist")
  }, datalist.map(function (option) {
    return _react.default.createElement("option", {
      value: option,
      key: option
    });
  }))), inputType === 'password' && _react.default.createElement("input", {
    value: value,
    placeholder: placeholder,
    onChange: onChange,
    onBlur: onBlur,
    onKeyDown: onKeyDown,
    id: uniqueID,
    className: (0, _classnames.default)('inputElement', {
      invalid: validationFailed
    }),
    readOnly: isReadOnly,
    disabled: isDisabled,
    type: "password"
  }), inputType === 'multipleLineText' && _react.default.createElement("textarea", {
    value: value,
    placeholder: placeholder,
    onChange: onChange,
    onBlur: onBlur,
    onKeyDown: onKeyDown,
    id: uniqueID,
    className: (0, _classnames.default)('inputElement', {
      invalid: validationFailed
    }),
    readOnly: isReadOnly,
    disabled: isDisabled,
    autoFocus: autofocus
  }), inputType === 'number' && _react.default.createElement("input", _extends({
    type: "number"
  }, maxNumber !== undefined && {
    max: maxNumber
  }, minNumber !== undefined && {
    min: minNumber
  }, {
    step: numberStep || 1,
    value: value,
    placeholder: placeholder,
    onChange: onChange,
    onBlur: onBlur,
    onKeyDown: onKeyDown,
    id: uniqueID,
    className: (0, _classnames.default)('inputElement', {
      invalid: validationFailed
    }),
    readOnly: isReadOnly,
    disabled: isDisabled
  })), inputType === 'integer' && _react.default.createElement("input", _extends({
    type: "number"
  }, maxNumber !== undefined && {
    max: maxNumber
  }, minNumber !== undefined && {
    min: minNumber
  }, {
    step: numberStep ? Math.floor(numberStep) : 1,
    value: value,
    placeholder: placeholder,
    onChange: onChange,
    onBlur: onBlur,
    onKeyDown: onKeyDown,
    id: uniqueID,
    className: (0, _classnames.default)('inputElement', {
      invalid: validationFailed
    }),
    readOnly: isReadOnly,
    disabled: isDisabled
  }))), _react.default.createElement("span", {
    className: validationFailed ? 'errorMessage' : 'feedbackMessage'
  }, displayInfoText));
};
InputField.propTypes = {
  uniqueID: _propTypes.string.isRequired,
  onChange: _propTypes.func.isRequired,
  value: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]).isRequired,
  options: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    displayName: _propTypes.string.isRequired,
    value: _propTypes.string.isRequired
  })),
  validation: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    criteria: _propTypes.func.isRequired,
    message: _propTypes.string.isRequired
  })),
  inputType: (0, _propTypes.oneOf)(['dropDown', 'integer', 'multipleLineText', 'number', 'password', 'text']),
  onKeyDown: _propTypes.func,
  datalist: (0, _propTypes.arrayOf)(_propTypes.string),
  isDatalistFetching: _propTypes.bool,
  isDisabled: _propTypes.bool,
  explanation: _propTypes.string,
  label: _propTypes.string,
  maxNumber: _propTypes.number,
  minNumber: _propTypes.number,
  onBlur: _propTypes.func,
  placeholder: _propTypes.string,
  isReadOnly: _propTypes.bool,
  numberStep: _propTypes.number,
  isSmall: _propTypes.bool,
  isRequired: _propTypes.bool,
  autofocus: _propTypes.bool
};
var _default = InputField;
exports.default = _default;